
import { State } from "vuex-class";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { FilterItem } from "./FilterModel";

@Component({})
export default class MultiSelectionFilter extends Vue {
  @Prop({ default: "" })
  label: string;
  @Prop({ default: [] })
  options: FilterItem[];
  @Prop({ default: [] })
  values: FilterItem[];

  private selectorOptions: FilterItem[] = [];
  private selected: string[] = [];

  private get filterUsed() {
    return this.values && this.values.length;
  }

  created() {
    this.options.forEach(option => {
      this.selectorOptions.push({
        label: option.label,
        value: option.value
      });
    });
    this.onValuesChanged(this.values);
  }

  private filter(filterValue: string) {
    const filterValueLower = filterValue ? filterValue.toLowerCase() : null;
    return this.selectorOptions.filter(
      option =>
        !filterValue ||
        option.label.toLowerCase().indexOf(filterValueLower) !== -1
    );
  }

  @Watch("values", { deep: true })
  private onValuesChanged(newValues: FilterItem[]) {
    if (this.values) {
      if (
        this.values.length !== this.selected.length ||
        !this.selected.every(sel =>
          this.values.some(item => item.value === sel)
        )
      ) {
        this.selected = this.values.map(item => item.value);
      }
    }
  }

  @Watch("selected", { deep: true })
  private handleSelectionChange(newValues: string[]) {
    const selection = newValues.map(value =>
      this.selectorOptions.find(option => option.value === value)
    );
    this.$emit("update", selection);
  }
}
